<template>
  <div>
    <!-- Provient du back -->
    <!-- eslint-disable vue/no-v-html -->
    <div v-html="formParams.thanksMessage"></div>
    <!-- eslint-enable vue/no-v-html -->
    <div v-if="formParams.shareFB" class="fb-share-button" :data-href="url" data-layout="button_count" data-size="small">
      <a target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${encodedURI}&amp;src=sdkpreparse`" class="fb-xfbml-parse-ignore">{{
        t("PARTAGER_SUR_FACEBOOK")
      }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "HomeConfirmation",
  computed: {
    ...mapGetters(["formParams", "url", "t"]),
    encodedURI() {
      return encodeURIComponent(this.url)
    }
  }
}
</script>

<style scoped>
</style>
